import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useMemo } from "react";
import { getMenuItems } from "../drawer/menuConf";
import { useLocation, Link } from "react-router";

const MobileMenuList = ({ userType }) => {
  const location = useLocation();
  const menuItems = useMemo(() => getMenuItems(userType), [userType]);
  return (
    <List>
      {menuItems.map((item, index) => {
        const isSelected = location.pathname.startsWith(item.route);
        return (
          <ListItem key={index}>
            <ListItemButton
              component={Link}
              to={item.route}
              selected={isSelected}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "primary.main",
                  height: "64px",
                  borderRadius: "2px",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: isSelected ? "white" : "black",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{
                  ml: 1,
                  "& .MuiListItemText-primary": {
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    color: isSelected ? "white" : "black",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default MobileMenuList;
